<template>
  <div>
    <modal
      v-if="show"
      :show="show"
      :title="$t('deleteBusinessConfirmModal.title')"
      :description="$t('deleteBusinessConfirmModal.description')"
      @save="submit"
      save-text="Confirm"
      @close="close"
      :loading="loading"
      :sticky-header="true"
      hide-top-close-button
      max-width="450"
      primary-button-class="red white--text"
    />

    <modal
      v-if="showHasActiveSubscriptionModal && active_subscription_id"
      :show="showHasActiveSubscriptionModal"
      :title="$t('hasActiveSubscriptionErrorModal.title')"
      @close="showHasActiveSubscriptionModal = false"
      :loading="loading"
      :sticky-header="true"
      hide-top-close-button
      max-width="450"
      primary-button-class="d-none"
    >
      <div class="pa-4 text-center font-weight-medium">
        <p>
          {{ $t('hasActiveSubscriptionErrorModal.description') }}
          <br><br>
          {{ $t('hasActiveSubscriptionErrorModal.cancelSubscription') }}:
        </p>
        <v-btn
          :to="{ name: 'my-subscriptions.subscription-single', params: { id: active_subscription_id } }"
          outlined
          class="text-capitalize"
        >
          {{ $t('Manage subscription') }}
        </v-btn>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  props: {
    show: {
      required: true,
      type: Boolean,
    },
    placeId: {
      required: true,
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showHasActiveSubscriptionModal: false,
      active_subscription_id: null,
    };
  },
  computed: {
    ...mapGetters(['loading']),
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch('loading', true);
      axios.post(`panel/ads/places/${this.placeId}/delete`)
        .then(() => {
          this.$store.dispatch('message', this.$t('Business deleted successfully'));
          this.$emit('deleted');
          this.close();
          this.$store.dispatch('loading', false);
        })
        .catch((error) => {
          this.close();
          if (error.response.data.has_active_subscription && error.response.data.active_subscription_id) {
            this.active_subscription_id = error.response.data.active_subscription_id;
            this.showHasActiveSubscriptionModal = true;
          } else {
            this.$store.dispatch('message', this.$t('Error deleting business'));
          }
          this.$store.dispatch('loading', false);
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
